module.exports = __webpack_public_path__ + "static/media/grid-view.d8a62746.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/grid-view.svg
// module id = ./src/assets/icons/grid-view.svg
// module chunks = 0